import React from "react";
import MasterRateCardTab from "./MasterRateCardTab";
const DefaultRateCard = () => {
  return <MasterRateCardTab />;
};
export default DefaultRateCard;
